import React, { useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { PauseCircle } from 'lucide-react';

const PENDING_REASONS = [
  { value: 'In attesa del cliente',           label: 'In attesa del cliente' },
  { value: 'In attesa di materiali',          label: 'In attesa di materiali' },
  { value: 'Bloccato - problema tecnico',     label: 'Bloccato - problema tecnico' },
  { value: 'In revisione / feedback atteso',  label: 'In revisione / feedback atteso' },
  { value: 'altro',                           label: 'Altro...' },
];

const PendingReasonModal = ({ task, isOpen, onClose, onConfirm }) => {
  const [selected, setSelected] = useState(null);
  const [customText, setCustomText] = useState('');
  const [loading, setLoading] = useState(false);

  if (!task) return null;

  const handleConfirm = async () => {
    const reason = selected === 'altro' ? customText.trim() : selected;
    if (!reason) return;
    setLoading(true);
    await onConfirm(reason);
    setLoading(false);
    setSelected(null);
    setCustomText('');
  };

  const handleClose = () => {
    setSelected(null);
    setCustomText('');
    onClose();
  };

  const isConfirmDisabled = loading
    || !selected
    || (selected === 'altro' && !customText.trim());

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="bg-zinc-900 border-zinc-800 max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display text-xl text-white flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-red-500/20 flex items-center justify-center flex-shrink-0">
              <PauseCircle className="w-5 h-5 text-red-400" />
            </div>
            Metti in Pausa l'Ordine
          </DialogTitle>
          <DialogDescription className="text-zinc-500 text-xs">
            Il Don vuole sapere perché ti fermi. Scegli un motivo.
          </DialogDescription>
        </DialogHeader>

        {/* Task summary */}
        <div className="bg-zinc-800/50 rounded-xl p-4 mb-2 border border-zinc-700">
          <p className="text-xs text-zinc-400 mb-1">Ordine in pausa:</p>
          <p className="font-semibold text-white">{task.title}</p>
        </div>

        {/* Reason list */}
        <div className="space-y-2 mb-2">
          {PENDING_REASONS.map(({ value, label }) => (
            <button
              key={value}
              onClick={() => setSelected(value)}
              className={`w-full text-left px-4 py-3 rounded-xl border transition-all text-sm font-medium
                ${selected === value
                  ? 'border-red-500/60 bg-red-500/10 text-red-300'
                  : 'border-zinc-700 bg-zinc-800/30 text-zinc-300 hover:border-zinc-600 hover:bg-zinc-800'
                }`}
            >
              {label}
            </button>
          ))}
        </div>

        {/* Free text for "Altro" */}
        {selected === 'altro' && (
          <div className="mb-2">
            <Input
              placeholder="Specifica il motivo..."
              value={customText}
              onChange={(e) => setCustomText(e.target.value)}
              className="bg-zinc-800 border-zinc-700 text-white placeholder:text-zinc-500"
              autoFocus
            />
          </div>
        )}

        {/* Actions */}
        <div className="flex gap-3 pt-2">
          <Button
            variant="outline"
            className="flex-1 border-zinc-700 text-zinc-400"
            onClick={handleClose}
          >
            Annulla
          </Button>
          <Button
            className="flex-1 bg-red-700 hover:bg-red-600 text-white font-bold"
            onClick={handleConfirm}
            disabled={isConfirmDisabled}
          >
            {loading ? (
              <span className="flex items-center gap-2">
                <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                Registrando...
              </span>
            ) : (
              <>
                <PauseCircle className="w-4 h-4 mr-2" />
                METTI IN PAUSA
              </>
            )}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PendingReasonModal;
